const isFlaggingEnabled = process.env.APP_MODE !== 'development';

export default {
  dashboard: {
    path: '/dashboard',
    isDisabled: isFlaggingEnabled,
    isShown: !isFlaggingEnabled,
  },
  account: {
    path: '/account',
    isShown: true,
  },
  'all-accounts': {
    path: '/all-accounts',
    isShown: true,
    roles: { // TODO: CHECK IF THIS PART IS VALID, IF NOT - DELETE RELATED CODE
      admin: {
        isShown: true,
      },
      editor: {
        isShown: true,
      },
      writer: {
        isShown: true,
      },
      customer: {
        isShown: true,
      },
      sale: {
        isShown: true,
      },
      developmentalEditor: {
        isShown: true,
      },
      contributor: {
        isShown: true,
      },
    },
    allFiltersNames: { // TODO: CHECK IF THIS PART IS VALID, IF NOT - DELETE RELATED CODE
      firstName: {
        isShown: true,
      },
      lastName: {
        isShown: true,
      },
      role: {
        isShown: true,
      },
      level: {
        isShown: true,
      },
      'address.country': {
        isShown: true,
      },
    },
  },
  'all-projects': {
    path: '/all-projects',
    isShown: true,
    tableColumns: { // TODO: CHECK IF THIS PART IS VALID, IF NOT - DELETE RELATED CODE
      customer: {
        isShown: true,
      },
      projectType: {
        isShown: true,
      },
      editor: {
        isShown: true,
      },
      writer: {
        isShown: !isFlaggingEnabled,
      },
      stage: {
        isShown: !isFlaggingEnabled,
      },
      dueDate: {
        isShown: !isFlaggingEnabled,
      },
    },
    allFiltersNames: { // TODO: CHECK IF THIS PART IS VALID, IF NOT - DELETE RELATED CODE
      'customer.country': {
        isShown: true,
      },
      'customer.name': {
        isShown: true,
      },
      isActive: {
        isShown: true,
      },
      'editor.name': {
        isShown: true,
      },
      'writer.name': {
        isShown: true,
      },
      deadlineDate: {
        isShown: !isFlaggingEnabled,
      },
    },
  },
  'projects-feedback': {
    path: '/projects-feedback',
    isShown: true,
  },
  'onboarding-feedback': {
    path: '/onboarding-feedback',
    isShown: true,
  },
  'proof-feedback': {
    path: '/proof-feedback',
    isShown: true,
  },
  'writer-feedback': {
    path: '/writer-feedback',
    isShown: true,
  },
  projects: {
    path: '/projects/create',
    isShown: true,
  },
  'project-overview': {
    path: '/project-overview',
    isShown: true,
  },
  project: {
    path: '/project',
    isShown: true,
    isShownAIChatbot: !isFlaggingEnabled,
    isProofreadButton: true,
    subRoutes: {
      outline: {
        isShown: true,
      },
      'questionnaire-answers': {
        isShown: true,
      },
      'questionnaire-creator': {
        isShown: true,
        actions: {
          addNewSectionBtn: false,
          addNewQuestionBtn: false,
          editSectionName: false,
          editQuestion: false,
        },
      },
      'writer-match': {
        isShown: true,
      },
      account: {
        isShown: true,
      },
      interviews: {
        isShown: true,
      },
      'book-specification': {
        isShown: true,
      },
      'final-proof': {
        isShown: true,
      },
      'sample-chapter': {
        isShown: true,
      },
      photos: {
        isShown: true,
      },
      'cover-creator': {
        isShown: true,
        path: '/cover-creator',
      },
      chapters: {
        isShown: true,
      },
      upgrades: {
        path: '/upgrades',
        isShown: true,
      },
      'style-samples': {
        path: 'style-samples',
        isShown: true,
      },
      'book-sample': {
        path: '/book-sample',
        isShown: true,
      },
    },
  },
  projectsW: {
    path: '/projectsW/:projectId/writer-match',
    isShown: true,
  },
  'offline-writer-match': {
    path: '/offline-writer-match',
    isShown: true,
  },
  'offline-writer-match-result': {
    path: '/offline-writer-match-result',
    isShown: true,
  },
  'upgrades-table': {
    path: '/upgrades-table',
    isShown: true,
  },
  isShownCustomUpgradeRequests: true,
  isShownPriceOfPaperbackCopies: false,
};
